import { render, staticRenderFns } from "./PaymentMethods.vue?vue&type=template&id=1072a970&"
import script from "./PaymentMethods.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethods.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethods.vue?vue&type=style&index=0&id=1072a970&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports